import React from 'react';

interface HeroProps {
  onStart?: () => void;
  onQuestionnaire?: () => void;
}

const Hero: React.FC<HeroProps> = ({ onStart, onQuestionnaire }) => {
  return (
    <section
      className="relative text-center h-max py-12 md:pt-28 md:pb-24 lg:pt-32 lg:pb-28 px-4 animate-fade-in-up"
    >
      <img
        src={`${process.env.PUBLIC_URL}/eta_photos/Mult Beads.webp`}
        alt=""
        aria-hidden="true"
        loading="eager"
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      {/* Soft white overlay keeps text readable — tune opacity if you want more photo visible */}
      <div className="absolute inset-0 bg-white/75" />

      {/* Content sits above the bg + overlay */}
      <div className="relative z-10 mx-auto max-w-5xl flex flex-col items-center">
        <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-mainPink tracking-tight leading-tight">
          ETA Learning
        </h1>
        <p className="mt-6 md:mt-8 lg:mt-7 text-2xl sm:text-3xl lg:text-4xl font-semibold text-black">
          Help your child understand the work—not just finish it.
        </p>
        <p className="mt-4 md:mt-6 lg:mt-6 text-xl lg:text-2xl font-extrabold text-mainBlue">
          Hands-on learning. Foundations that last. Success beyond the classroom.
        </p>
        <p className="mt-4 md:mt-6 lg:mt-5 text-xl lg:text-2xl text-black">
          Small-group, <strong>3:1 tutoring</strong> ensures individualized attention.
        </p>
        <p className="mt-6 md:mt-8 lg:mt-8 max-w-3xl lg:max-w-4xl text-xl lg:text-2xl text-gray-800 leading-relaxed">
          A blend of <strong>Montessori-inspired learning</strong> with{' '}
          <strong>structured academic support</strong>. Each child receives a{' '}
          <strong>personalized plan</strong>, <strong>take-home reinforcement</strong>,{' '}
          <strong>assessments</strong>, and{' '}
          <strong>academic &amp; behavioural progress reports every session</strong>.
        </p>
        <button
          onClick={() => onQuestionnaire ? onQuestionnaire() : onStart && onStart()}
          className="mt-10 mb-6 w-full sm:w-auto inline-flex items-center justify-center rounded-full bg-mainPink px-6 sm:px-10 lg:px-16 py-4 sm:py-4 lg:py-5 text-sm sm:text-base lg:text-lg font-semibold text-white transition duration-300 hover:bg-mainBlue break-words"
        >
          What&rsquo;s the ETA of your learning goal?
        </button>
      </div>
    </section>
  );
};

export default Hero;
